import { PxtraApiClientLegacy } from '@pxtra-client-lib-legacy';
import AuthenticationStore from './authenticationStore';
import BenefitsStore from './benefitsStore';
import CompanyStore from './companyStore';
import ImpexStore from './impexStore';
import ReceiptStore from './receipts/details';
import { NavigateFunction } from 'react-router';
import { TFunction } from 'i18next';
import EmployeeStore from './employee/details';
import { ReceiptListStore } from './receipts/list';
import { ExportFlowStore } from '../pages/exports/store/exportFlowStore';
export class RootStore {
  employeeStore: EmployeeStore;
  companyStore: CompanyStore;
  receiptStore: ReceiptStore;
  authenticationStore: AuthenticationStore;
  benefitsStore: BenefitsStore;
  impexStore: ImpexStore;
  receiptListStore: ReceiptListStore;
  exportFlowStore: ExportFlowStore;

  constructor(apiClient: PxtraApiClientLegacy, navigate: NavigateFunction, translate: TFunction) {
    this.authenticationStore = new AuthenticationStore(apiClient);
    this.companyStore = new CompanyStore(apiClient, this.authenticationStore);
    this.employeeStore = new EmployeeStore(apiClient, this.companyStore, this.authenticationStore);
    this.receiptStore = new ReceiptStore(apiClient, this.companyStore, this.authenticationStore);
    this.benefitsStore = new BenefitsStore(apiClient, this.companyStore, this.authenticationStore);
    this.impexStore = new ImpexStore(apiClient, this.companyStore, this.authenticationStore);

    this.receiptListStore = new ReceiptListStore(
      apiClient,
      this.authenticationStore,
      this.receiptStore,
      this.companyStore,
      navigate,
      translate
    );
    this.exportFlowStore = new ExportFlowStore();
  }
}
